export const DEFAULT_NAME = 'videai';
export const OSS_PATH =
  'https://vastx-1309865080.cos.ap-guangzhou.myqcloud.com/videai-web/dist/';
import IconFont from '@/components/IconFont';
export const HOME_CONFIG = {
  BANNER_ITEM_WIDTH: 636,
  BANNER_ITEM_WRAPPER_WIDTH: 636 + 6 * 2,
  BANNER_ITEM_MARGIN: 6,
  BANNER_ITEM_HEIGHT: 360,
};
export enum VIDEO_TAB_ENUM {
  Role = 'role',
  Shot = 'shot',
  ShotVideo = 'shotVideo',
}
export enum TASK_STAGE {
  Init = '0',
  RoleImg = '1',
  ShotImg = '2',
  ShotVideo = '3',
}
export enum TASK_STATUS {
  INIT = 'INIT',
  RUNNING = 'RUNNING',
  EXECUTING = 'EXECUTING',
  PAUSE = 'PAUSE',
  PENDING = 'PENDING',
  DONE = 'DONE',
  FAILED = 'FAILED',
}
export const FINISH_STATUS = [TASK_STATUS.DONE, TASK_STATUS.FAILED];
export enum TASK_STATUS_LABEL {
  INIT = '初始化',
  PENDING = '执行中',
  DONE = '执行完成',
  FAILED = '执行失败',
}
export const RATIO_ICON = {
  '16:9': <IconFont type="icon-ic_crop_16_91" />,
  '9:16': <IconFont type="icon-ic_crop_9_16" />,
  '3:4': <IconFont type="icon-ic_crop_3_4" />,
};
